module.exports = __webpack_public_path__ + "static/media/Dirt_Dealer.6eb23c44.png";